import store from '@/store'
export default [
    {
        path: '/event-managements',
        name: 'eventManagement',
        meta: { requiresAuth: true },
        component: () => import('@/pages/event-management/index.vue')
    },
    {
        path: '/event-management-register-mains',
        name: 'eventManagementRegisterMain',
        meta: { requiresGuest: true },
        component: () =>
            import('@/pages/event-management/event-management-register-main.vue')
    },
    {
        path: '/event-managements/:id/show',
        name: 'event-management-show',
        meta: { requiresAuth: true },
        component: () => import('@/pages/event-management/show.vue'),
        beforeEnter: async (to, from, next) => {
            await store.dispatch('eventManagement/find', to.params.id).then(() => {
                next()
            })
        }
    },
]

